import script from "/app/pages/Reports.vue?type=script";
import "/app/pages/Reports.vue?type=style";
import { render } from "/app/pages/Reports.vue?type=template";
script.render = render;
export default script;
